// eslint-disable-next-line import/prefer-default-export
export const notifications = {
  namespaced: true,
  state: {
    notifications:[],
    total: 10,
  },
  getters: {
    notifications(state) {
      return state.notifications
    },
    total(state) {
      return state.total
    },
  },
  mutations: {
    setNotifications(state, val) {
      state.notifications = val.data
      state.total = val.total
    },
    addNotification: (state, notification) => {
      state.notifications= [notification,...state.notifications]
      state.total = state.notifications.length
    },
    updateNotification: (state, notification) => {
      state.notifications = state.notifications.map(datum => {
        if (datum.id === notification.id) {
          return notification
        }
        return datum
      })
    },
    removeNotification: (state, id) => {
      state.notifications = state.notifications.filter(datum => +datum.id !== +id)
    },
  },
}
